import { call, put, takeLatest } from "redux-saga/effects";
import {
  deleteDepartmentStart,
  deleteDepartmentSuccess,
  deleteDepartmentFailure,
} from "../reducer";
import { networkErrorHandler } from "../../../utils/errorHandlers";
import { httpDeleteDepartment } from "../../../services/department";
import { successNotifier } from "../../../utils/helpers";

export function* deleteDepartment({ payload }) {
  const { id, callback } = payload;
  const response = yield call(httpDeleteDepartment, id);
  const { success, raw, message } = response;

  if (success) {
    yield put(deleteDepartmentSuccess());
    successNotifier("Department deleted successfully");
    if (callback) {
      callback();
    }
  } else {
    yield put(deleteDepartmentFailure(message || raw?.error));
    networkErrorHandler(response?.statusCode, message || raw?.error);
  }
}

export default function* onDeleteDepartment() {
  yield takeLatest(deleteDepartmentStart.type, deleteDepartment);
}
